import React from 'react';
import { Paper, Typography, Box, styled } from '@mui/material';

const TransactionCard = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  width: '100%',
  borderRadius: '12px',
  border: '1px solid #f7f2f2ff',
  maxHeight: '144px',
  minHeight: '100px',
}));

const StatusContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '4px',
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '32px',
  height: '32px',
  display: 'flex',
  marginBottom: '4px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}));

const StatusName = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  color: '#425166',
}));

const StatusCount = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: '#19273C',
}));

export default function TransactionStatusCard({ icon, iconColor, status, count }) {
  return (
    <TransactionCard iconColor={iconColor}>
      <StatusContainer>
      <IconContainer iconColor={iconColor}>
        <img src={icon} alt={status} />
      </IconContainer>
      <StatusName>{status}</StatusName>
      <StatusCount>{count?.toLocaleString() || '0'}</StatusCount>
      </StatusContainer>
    </TransactionCard>
  );
}

